__turbopack_context__.v({
  "documentsAsideHeader": "DocumentsAsideHeader-module__W6BkBW__documentsAsideHeader",
});
